
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
export default {
  components: {
    CoolLightBox
  },
  data() {
    return {
      images: [
        {
          title: 'Represented as a Goan Startup at the Startup 20 showcase 2023 organised at Grand hyatt Goa.',
          description: "G20 - Startup 20 ",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fstartup20.webp?alt=media&token=f210df4e-8ee8-4822-b338-3a90b93dfc3d&_gl=1*1j69nxg*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDk5NC4wLjAuMA.."
        },
        {
          title: 'Honored to have selected and  received seed fund from the Government if Goa to boost our startup. ',
          description: "Startup Journey",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fseed-fund.webp?alt=media&token=d2dfc5ff-5377-465f-85ac-252961459d79&_gl=1*1wrutta*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDg2NS4wLjAuMA.."
        },
        {
          title: 'Recognition and Support from the Startup Promotion Cell Of Goa and Goa Government',
          description: "Startup Journey",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fstartup-promotion'.webp?alt=media&token=38dfb1e1-e038-4c7a-bc0a-a9b684f521e5&_gl=1*1n1apkg*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDc5Mi4wLjAuMA.."
        },
        {
          title: 'Working is fun at our HQ at AIC GIM Foundation Goa',
          description: "Our HQ",
          src:"https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Foffice-2.webp?alt=media&token=2626ccda-a426-4346-8805-c010ff314ea5&_gl=1*3fjo11*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDU4OS4wLjAuMA.."
        },
        {
          title: 'Working on new innovations in Tourism Tech at Goa App HQ',
          description: "Our HQ",
          src:"https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Foffice-1.webp?alt=media&token=a6195574-10a8-454c-ab5a-f37402377de6&_gl=1*tpw9tw*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDUxMS4wLjAuMA..",
        },
        {
          title: 'Article Published About Goa App on ItsGoa E-Magazine',
          description: "Recognitions",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fits-goa.webp?alt=media&token=46c29d24-2766-4590-8cc1-4554d47a1575&_gl=1*1nx36ml*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDQ0OC4wLjAuMA.."
        },
        {
          title: 'Playing Foosball game with interns',
          description: "Foosball game",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4882.webp?alt=media&token=6aeee4dd-2ec0-47e7-b256-96f80ba3ca78"
        },
        {
          title: 'CEO of Goa App giving presentation to investor',
          description: "G20 investor call at grand hayat",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2F20230603_191350.webp?alt=media&token=7ef4bbc4-7b3b-4d43-b7f1-cb2ab17c1d36"
        },
        {
          title: 'Founder and Co-founder at G20',
          description: "G20 Session",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2F20230603_191547.webp?alt=media&token=975266e4-058e-4836-8d30-351bf6daa321"
        },
        {
          title: 'Founder at GIM Office',
          description: "Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4761.webp?alt=media&token=a728c307-1514-4dd5-8f68-1f46715a2e7d"
        },
        {
          title: 'Internship at GIM Office',
          description: "Internship students at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4822.webp?alt=media&token=132ebb8d-4c11-4b71-8b56-9bfa870826e6"
        },
        {
          title: 'Internship at GIM Office',
          description: "Internship students at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4862.webp?alt=media&token=94bcddfa-5597-4f8b-a7de-7c9601350a8d"
        },
        {
          title: 'Teaching Interns at GIM Office',
          description: "Internship students from GEC at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4902.webp?alt=media&token=2c288ef8-003a-471f-9e85-930a7d8ba189"
        },
        {
          title: 'Cheers to the days when we started building Goa App',
          description: "Summer Internship",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fsummer-internship.webp?alt=media&token=b616245a-fe23-4e0a-ab0c-c9253c3330a6&_gl=1*xn5kli*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDY1Mi4wLjAuMA.."
        },
        {
          title: 'Teaching Interns at GIM Office',
          description: "Internship students from GEC at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4925.webp?alt=media&token=bd93d912-7d83-4fa5-8d95-feebc2294785"
        },
        {
          title: 'Partnership with Hotel Amani Vagator Goa for Exclusive Offers',
          description: "Parnerships",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fhotel-amani.webp?alt=media&token=18399141-1c33-487b-ba8b-9df936f2938d&_gl=1*1o6cq9z*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDM4OC4wLjAuMA.."
        },
        {
          title: 'Partnership with Hotel Goa Continental Baga for Exclusive Offers',
          description: "Parnerships",
          src:"https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fgoa-continental.webp?alt=media&token=12b5da10-f34d-46cc-b138-c728e5856db4&_gl=1*6erytb*_ga*NDU3MjE1MDQ0LjE2NzA1NjQxOTc.*_ga_CW55HF8NVT*MTY4NjYzNDIyMS40LjEuMTY4NjYzNDMyNy4wLjAuMA.."
        },
        {
          title: 'Official Ticketing Partners for Goa Marathi Film Festival 2022',
          description: "GMFF 2022",
          src: "https://firebasestorage.googleapis.com/v0/b/goa-app-12a91.appspot.com/o/about-us-images%2Fgmff.webp?alt=media&token=cf471e43-8653-45af-b866-924e875367fb"
        },
        {
          title: 'Teaching AITD Interns at Appbuddy Office',
          description: "Internship students from AITD at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4929.webp?alt=media&token=1109a8be-99d6-4f58-8ad5-89611f84925b"
        },
        {
          title: 'Teaching AITD Interns at Appbuddy Office',
          description: "Internship students from AITD at Atal Incubation Center",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FIMG_4965.webp?alt=media&token=73c18296-285d-4caa-9931-3aa480304453"
        },
        {
          title: 'Talk by Radhaprasad Borkar at Appbuddy Office',
          description: "Radhaprasad Borkar CEO at Appbuddy",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FWhatsApp%20Image%202024-04-19%20at%201.26.01%20AM.webp?alt=media&token=b9f9d529-fa19-41cf-9a8d-c5fc0a0c2dfe"
        },
        {
          title: 'Talk by Radhaprasad Borkar at GEC College',
          description: "Radhaprasad Borkar at Goa College of Engineering",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FWhatsApp%20Image%202024-04-19%20at%201.31.03%20AM.webp?alt=media&token=b902939e-941c-47e8-90b6-2ccc8316c59d"
        },
        {
          title: 'Radhaprasad Borkar Honored at GSB Utkarsh Mandal Awards Ceremony',
          description: "Radhaprasad Borkar was honored with an award at the GSB Utkarsh Mandal Awards Ceremony for his outstanding achievements.",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FWhatsApp%20Image%202024-04-19%20at%201.26.14%20AM.webp?alt=media&token=0796bd96-a06e-4e9c-a120-1b2ae5700f06"
        },
        {
          title: 'Talk by Radhaprasad Borkar on Android',
          description: "Radhaprasad Borkar taking course on Android App Development",
          src: "https://firebasestorage.googleapis.com/v0/b/goaapp-test.appspot.com/o/about_us%2FWhatsApp%20Image%202024-04-19%20at%201.26.52%20AM.webp?alt=media&token=69891524-f3d9-4bde-b17c-121ec3d07bca"
        },
      ],
      index: null,
    };
  },
}
